import { Box } from '@mui/material'
import { useContext } from 'react'
import { OnboardingContext } from '../context/onboarding/OnboardingContext'
import Actions from './Actions'
import { Form } from '@wolfdanepug/common-react'

export default function StepForm({ children, sx = {} }: any) {
	const { useOnboardingState, onSubmit } = useContext(OnboardingContext)
	const { actionsOpen }: any = useOnboardingState()

	return (
		<Form onSubmit={onSubmit} sx={{ ...styles.form, ...sx.form }}>
			<Box sx={{ ...styles.content, ...sx.content }}>{children}</Box>
			{actionsOpen && <Actions />}
		</Form>
	)
}

const styles = {
	form: {
		// height: '100%'
		// width: '100%',
		// minHeight: 220,
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
		// justifyContent: 'center',
		// alignItems: 'flex-start'
	},
	content: {
		display: 'flex',
		flex: 1,
		justifyContent: 'center',
		// alignItems: 'center',
		flexDirection: 'column'
		// width: '100%'
		// height: '100%'
	}
}
